import request from "@/utils/request";
// 首页
export function getHomeData(data){
    return request({
        url:'/getHomeData',
        data:data,
        method:'get'
    })
}
